import { useState, useEffect } from 'react';
import LicenseService from '../services/LicenseService';

const useEmailValidation = (initialEmail = '') => {
  const [email, setEmail] = useState(initialEmail);
  const [isValidating, setIsValidating] = useState(false);
  const [validationResult, setValidationResult] = useState(null); // { success, message, valid, available }

  useEffect(() => {
    if (!email || email.length < 5) {
      setValidationResult(null);
      return;
    }

    setIsValidating(true);
    const handler = setTimeout(async () => {
      try {
        const result = await LicenseService.validateEmail(email);
        setValidationResult(result);
      } catch (error) {
        setValidationResult({
          success: false,
          message: 'Erro ao validar email.',
          valid: false,
          available: false,
        });
      } finally {
        setIsValidating(false);
      }
    }, 500); // Debounce de 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [email]);

  return { email, setEmail, isValidating, validationResult };
};

export default useEmailValidation;
